import { deleteCookie } from '../../../helpers/cookie';
import { DEFAULT_FLASH_MESSAGE_KEY } from '../config/config';

export const deleteFlashMessage = (cookieKey = DEFAULT_FLASH_MESSAGE_KEY) => deleteCookie(cookieKey);

export default deleteFlashMessage;
